export enum ReportType {
  Internal = "Internal",
  External = "External",
}
